import { IPermissionProps } from '@/types/shared'
import React from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { Button, FormItem, GridInformation } from 'vnetwork-ui'
import { useNavigate } from 'react-router-dom'
import SubHeaders from '@/components/Headers/SubHeaders'
import { paths } from '@/utils/path'
import { createJobCategory } from '../../services'
import { JobCategory } from '../../types'
import { createJobCategorySchema } from './yup'
import { yupResolver } from '@hookform/resolvers/yup'
import useDataGridRefetch from '@/hooks/useDataGridRefetch'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const Create: React.FC<IPermissionProps> = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { refetchCurrent } = useDataGridRefetch({
        reactQueryKey: 'job-categories',
    })
    const { mutateAsync: create, isPending: isCreating } =
        useMutationWithHandler(
            {
                mutationFn: createJobCategory,
            },
            {
                reactQueryKeys: QUERY_KEYS.JOBS,
                successMessage: 'Created job category success',
                onSuccess: () => {
                    navigate('/job-categories')
                },
            }
        )
    const { control, handleSubmit } = useForm<JobCategory>({
        defaultValues: {
            title: '',
            description: '',
        },
        //@ts-ignore
        resolver: yupResolver(createJobCategorySchema),
    })

    const onSubmit: any = async (values: JobCategory) => {
        const dataToSubmit = {
            ...values,
        }

        console.log('dataToSubmit', dataToSubmit)
        try {
            await create(dataToSubmit)
            refetchCurrent()
        } catch (error) {
            console.error('Error submitting form', error)
        }
    }
    return (
        <>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    {
                        path: '/job-categories',
                        title: t('job-categories-list'),
                    },
                    {
                        path: paths.jobCategoryCreate,
                        title: t('job-category-create'),
                    },
                ]}
            />
            <form onSubmit={handleSubmit(onSubmit)}>
                <GridInformation
                    data={[
                        {
                            label: t('job-category-title'),
                            value: (
                                <FormItem
                                    className="my-2"
                                    control={control}
                                    name="title"
                                    type="textfield"
                                    placeholder={t('input-category-title')}
                                />
                            ),
                        },
                        {
                            label: t('job-category-description'),
                            value: (
                                <FormItem
                                    className="my-2"
                                    control={control}
                                    name="description"
                                    type="textfield"
                                    placeholder={t(
                                        'input-category-description'
                                    )}
                                />
                            ),
                            className: 'col-span-2',
                        },
                        {
                            label: '',
                            value: (
                                <Button
                                    className="mt-6"
                                    type="submit"
                                    disabled={isCreating}
                                >
                                    {t('job-category-create')}
                                </Button>
                            ),
                        },
                    ]}
                    head={{
                        title: t('job-category-create'),
                    }}
                />
            </form>
        </>
    )
}

export default Create
